import React, { useState } from 'react';

export const CountryCodes = [
    { code: '+1', name: 'Estados Unidos' },
    { code: '+7', name: 'Rusia' },
    { code: '+20', name: 'Egipto' },
    { code: '+27', name: 'Sudáfrica' },
    { code: '+30', name: 'Grecia' },
    { code: '+31', name: 'Países Bajos' },
    { code: '+32', name: 'Bélgica' },
    { code: '+33', name: 'Francia' },
    { code: '+34', name: 'España' },
    { code: '+36', name: 'Hungría' },
    { code: '+39', name: 'Italia' },
    { code: '+40', name: 'Rumania' },
    { code: '+41', name: 'Suiza' },
    { code: '+43', name: 'Austria' },
    { code: '+44', name: 'Reino Unido' },
    { code: '+45', name: 'Dinamarca' },
    { code: '+46', name: 'Suecia' },
    { code: '+47', name: 'Noruega' },
    { code: '+48', name: 'Polonia' },
    { code: '+49', name: 'Alemania' },
    { code: '+51', name: 'Perú' },
    { code: '+52', name: 'México' },
    { code: '+53', name: 'Cuba' },
    { code: '+54', name: 'Argentina' },
    { code: '+55', name: 'Brasil' },
    { code: '+56', name: 'Chile' },
    { code: '+57', name: 'Colombia' },
    { code: '+58', name: 'Venezuela' },
    { code: '+60', name: 'Malasia' },
    { code: '+61', name: 'Australia' },
    { code: '+62', name: 'Indonesia' },
    { code: '+63', name: 'Filipinas' },
    { code: '+64', name: 'Nueva Zelanda' },
    { code: '+65', name: 'Singapur' },
    { code: '+66', name: 'Tailandia' },
    { code: '+81', name: 'Japón' },
    { code: '+82', name: 'Corea del Sur' },
    { code: '+84', name: 'Vietnam' },
    { code: '+86', name: 'China' },
    { code: '+90', name: 'Turquía' },
    { code: '+91', name: 'India' },
    { code: '+92', name: 'Pakistán' },
    { code: '+93', name: 'Afganistán' },
    { code: '+94', name: 'Sri Lanka' },
    { code: '+95', name: 'Myanmar' },
    { code: '+98', name: 'Irán' },
    { code: '+211', name: 'Sudán del Sur' },
    { code: '+212', name: 'Marruecos' },
    { code: '+213', name: 'Argelia' },
    { code: '+216', name: 'Túnez' },
    { code: '+218', name: 'Libia' },
    { code: '+220', name: 'Gambia' },
    { code: '+221', name: 'Senegal' },
    { code: '+222', name: 'Mauritania' },
    { code: '+223', name: 'Malí' },
    { code: '+224', name: 'Guinea' },
    { code: '+225', name: 'Costa de Marfil' },
    { code: '+226', name: 'Burkina Faso' },
    { code: '+227', name: 'Níger' },
    { code: '+228', name: 'Togo' },
    { code: '+229', name: 'Benín' },
    { code: '+230', name: 'Mauricio' },
    { code: '+231', name: 'Liberia' },
    { code: '+232', name: 'Sierra Leona' },
    { code: '+233', name: 'Ghana' },
    { code: '+234', name: 'Nigeria' },
    { code: '+235', name: 'Chad' },
    { code: '+236', name: 'República Centroafricana' },
    { code: '+237', name: 'Camerún' },
    { code: '+238', name: 'Cabo Verde' },
    { code: '+239', name: 'Santo Tomé y Príncipe' },
    { code: '+240', name: 'Guinea Ecuatorial' },
    { code: '+241', name: 'Gabón' },
    { code: '+242', name: 'República del Congo' },
    { code: '+243', name: 'República Democrática del Congo' },
    { code: '+244', name: 'Angola' },
    { code: '+245', name: 'Guinea-Bisáu' },
    { code: '+246', name: 'Diego García' },
    { code: '+247', name: 'Ascensión' },
    { code: '+248', name: 'Seychelles' },
    { code: '+249', name: 'Sudán' },
    { code: '+250', name: 'Ruanda' },
    { code: '+251', name: 'Etiopía' },
    { code: '+252', name: 'Somalia' },
    { code: '+253', name: 'Yibuti' },
    { code: '+254', name: 'Kenia' },
    { code: '+255', name: 'Tanzania' },
    { code: '+256', name: 'Uganda' },
    { code: '+257', name: 'Burundi' },
    { code: '+258', name: 'Mozambique' },
    { code: '+260', name: 'Zambia' },
    { code: '+261', name: 'Madagascar' },
    { code: '+262', name: 'Reunión' },
    { code: '+263', name: 'Zimbabue' },
    { code: '+264', name: 'Namibia' },
    { code: '+265', name: 'Malaui' },
    { code: '+266', name: 'Lesoto' },
    { code: '+267', name: 'Botsuana' },
    { code: '+268', name: 'Esuatini' },
    { code: '+269', name: 'Comoras' },
    { code: '+291', name: 'Eritrea' },
    { code: '+297', name: 'Aruba' },
    { code: '+298', name: 'Islas Feroe' },
    { code: '+299', name: 'Groenlandia' },
    { code: '+350', name: 'Gibraltar' },
    { code: '+351', name: 'Portugal' },
    { code: '+352', name: 'Luxemburgo' },
    { code: '+353', name: 'Irlanda' },
    { code: '+354', name: 'Islandia' },
    { code: '+355', name: 'Albania' },
    { code: '+356', name: 'Malta' },
    { code: '+357', name: 'Chipre' },
    { code: '+358', name: 'Finlandia' },
    { code: '+359', name: 'Bulgaria' },
    { code: '+370', name: 'Lituania' },
    { code: '+371', name: 'Letonia' },
    { code: '+372', name: 'Estonia' },
    { code: '+373', name: 'Moldavia' },
    { code: '+374', name: 'Armenia' },
    { code: '+375', name: 'Bielorrusia' },
    { code: '+376', name: 'Andorra' },
    { code: '+377', name: 'Mónaco' },
    { code: '+378', name: 'San Marino' },
    { code: '+380', name: 'Ucrania' },
    { code: '+381', name: 'Serbia' },
    { code: '+382', name: 'Montenegro' },
    { code: '+383', name: 'Kosovo' },
    { code: '+385', name: 'Croacia' },
    { code: '+386', name: 'Eslovenia' },
    { code: '+387', name: 'Bosnia y Herzegovina' },
    { code: '+389', name: 'Macedonia del Norte' },
    { code: '+420', name: 'Chequia' },
    { code: '+421', name: 'Eslovaquia' },
    { code: '+423', name: 'Liechtenstein' },
    { code: '+500', name: 'Islas Malvinas' },
    { code: '+501', name: 'Belice' },
    { code: '+502', name: 'Guatemala' },
    { code: '+503', name: 'El Salvador' },
    { code: '+504', name: 'Honduras' },
    { code: '+505', name: 'Nicaragua' },
    { code: '+506', name: 'Costa Rica' },
    { code: '+507', name: 'Panamá' },
    { code: '+508', name: 'San Pedro y Miquelón' },
    { code: '+509', name: 'Haití' },
    { code: '+590', name: 'Guadalupe' },
    { code: '+591', name: 'Bolivia' },
    { code: '+592', name: 'Guyana' },
    { code: '+593', name: 'Ecuador' },
    { code: '+594', name: 'Guayana Francesa' },
    { code: '+595', name: 'Paraguay' },
    { code: '+597', name: 'Surinam' },
    { code: '+598', name: 'Uruguay' },
    { code: '+599', name: 'Antillas Neerlandesas' },
    { code: '+670', name: 'Timor Oriental' },
    { code: '+672', name: 'Islas Norfolk' },
    { code: '+673', name: 'Brunéi' },
    { code: '+674', name: 'Nauru' },
    { code: '+675', name: 'Papúa Nueva Guinea' },
    { code: '+676', name: 'Tonga' },
    { code: '+677', name: 'Islas Salomón' },
    { code: '+678', name: 'Vanuatu' },
    { code: '+679', name: 'Fiyi' },
    { code: '+680', name: 'Palaos' },
    { code: '+681', name: 'Wallis y Futuna' },
    { code: '+682', name: 'Islas Cook' },
    { code: '+683', name: 'Niue' },
    { code: '+685', name: 'Samoa' },
    { code: '+686', name: 'Kiribati' },
    { code: '+687', name: 'Nueva Caledonia' },
    { code: '+688', name: 'Tuvalu' },
    { code: '+689', name: 'Polinesia Francesa' },
    { code: '+690', name: 'Tokelau' },
    { code: '+691', name: 'Micronesia' },
    { code: '+692', name: 'Islas Marshall' },
    { code: '+850', name: 'Corea del Norte' },
    { code: '+852', name: 'Hong Kong' },
    { code: '+853', name: 'Macao' },
    { code: '+855', name: 'Camboya' },
    { code: '+856', name: 'Laos' },
    { code: '+880', name: 'Bangladés' },
    { code: '+886', name: 'Taiwán' },
    { code: '+960', name: 'Maldivas' },
    { code: '+961', name: 'Líbano' },
    { code: '+962', name: 'Jordania' },
    { code: '+963', name: 'Siria' },
    { code: '+964', name: 'Irak' },
    { code: '+965', name: 'Kuwait' },
    { code: '+966', name: 'Arabia Saudita' },
    { code: '+967', name: 'Yemen' },
    { code: '+968', name: 'Omán' },
    { code: '+970', name: 'Palestina' },
    { code: '+971', name: 'Emiratos Árabes Unidos' },
    { code: '+972', name: 'Israel' },
    { code: '+973', name: 'Baréin' },
    { code: '+974', name: 'Catar' },
    { code: '+975', name: 'Bután' },
    { code: '+976', name: 'Mongolia' },
    { code: '+977', name: 'Nepal' },
    { code: '+992', name: 'Tayikistán' },
    { code: '+993', name: 'Turkmenistán' },
    { code: '+994', name: 'Azerbaiyán' },
    { code: '+995', name: 'Georgia' },
    { code: '+996', name: 'Kirguistán' },
    { code: '+998', name: 'Uzbekistán' },
  ];